import React from "react";

import {
  Card,
  Modal as MuiModal,
  ModalProps as MuiModalProps,
} from "@mui/material";
import styled from "@mui/material/styles/styled";

export interface ModalProps
  extends Omit<MuiModalProps, "onClose" | "children" | "reason"> {
  children: React.ReactNode;
  onClose?: (
    event: React.MouseEvent | React.KeyboardEvent,
    reason: "backdropClick" | "escapeKeyDown" | "buttonClick",
  ) => void;
}

const StyledCard = styled(Card)({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "95%",
  maxHeight: "95%",
  overflowY: "auto",
});

const Modal = ({ children, sx, ...modalProps }: ModalProps) => (
  <MuiModal disableAutoFocus disableScrollLock {...modalProps}>
    <StyledCard sx={sx}>{children}</StyledCard>
  </MuiModal>
);

export default Modal;
